import type { Database } from "@shared/database.types";
import type { Tag } from "./_shared";

export type ShiftType = Database["public"]["Enums"]["shift_type"];

export const SHIFT_TYPE_LABELS: Record<ShiftType, string> = {
  full_day: "Full Day",
  morning: "Morning",
  afternoon: "Afternoon",
  custom: "Custom",
};

export const SHIFT_TYPE_OPTIONS: Tag[] = (
  Object.keys(SHIFT_TYPE_LABELS) as ShiftType[]
).map((value) => ({ value, label: SHIFT_TYPE_LABELS[value] }));

export function shiftTypeLabel(
  value: ShiftType | null | undefined
): string | null {
  return value ? SHIFT_TYPE_LABELS[value] : null;
}
